'use client';

import { useState } from 'react';

import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import { GoogleIcon } from '@/assets';
import { Button, Divider, Form, FormInputField } from '@/components';
import { authClient } from '@/lib';
import { logger } from '@/lib/logger';
import { cn } from '@/lib/utils';
import { signUpFormSchema } from '@/zod-schema';

/**
 * @file sign-up-form.jsx
 * @description Sign up form
 * @version 0.0.1
 * Created at: 11/08/2025
 * Updated at: 11/08/2025
 */
export const SignUpForm = ({  className }) => {
  //-------------- State & Variables --------------//
  const [error, setError] = useState(null);
  const form = useForm({
    resolver: zodResolver(signUpFormSchema),
    defaultValues: {
      name: '',
      email: '',
      password: '',
      confirmPassword: '',
    },
  });

  //-------------- Use Effects --------------//

  //-------------- Other Methods --------------//
  /**
   * Handle form submission
   */
  const onSubmit = async (values) => {
    try {
       await authClient.signUp.email({
        name: values.name,
        email: values.email,
        password: values.password,
        callbackURL: '/',
      });
    } catch (err) {
      logger.error('Sign up failed', err, { context: 'SignUpForm' });
      setError('Login failed');
    }
  };

  return (
    <div>
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className={cn('mt-4 space-y-8', className)}>
          {/* Name */}
          <FormInputField form={form} name={'name'} label="Name" placeholder="John Doe" />
          {/* Email */}
          <FormInputField form={form} name={'email'} label="Email" placeholder="email@gmail.com" />
          {/* Password */}
          <FormInputField
            form={form}
            name={'password'}
            type="password"
            label="Password"
            placeholder="*******"
          />
          {/* Confirm Password */}
          <FormInputField
            form={form}
            name={'confirmPassword'}
            type="password"
            label="Confirm Password"
            placeholder="*******"
          />

          {error && <div className="text-center text-sm text-red-500">{error}</div>}
          <Button type="submit" className={'w-full'}>
            Submit
          </Button>
        </form>
      </Form>

      <Divider className={'mt-6'}>Or continue with</Divider>
      <Button variant={'outline'} className={'mt-5 w-full'}>
        <GoogleIcon />
        Login with Google
      </Button>
    </div>
  );
};
